{
  "schema_version": "demo-1.0",
  "scenario": {
    "id": "demo-alpha",
    "name": "Demo Alpha / High Desert Transit",
    "seed": 182736,
    "clock": "14:32:10Z",
    "area": "Indian approach corridor",
    "status": "RUNNING"
  },
  "sources": [
    {
      "id": "SYNTH-DEMO-ALPHA",
      "name": "Alpha flight synthesizer",
      "type": "SYNTHESIZER",
      "adapter": "demo-air-v1",
      "adapter_version": "1.4.2",
      "status": "ACTIVE",
      "last_message": "14:32:09.847Z",
      "accepted": 1842,
      "rejected": 3,
      "rate": "4.8 msg/s"
    },
    {
      "id": "SYNTH-GROUND-01",
      "name": "Ground route synthesizer",
      "type": "SYNTHESIZER",
      "adapter": "demo-ground-v1",
      "adapter_version": "1.1.8",
      "status": "ACTIVE",
      "last_message": "14:32:10.018Z",
      "accepted": 927,
      "rejected": 0,
      "rate": "2.1 msg/s"
    },
    {
      "id": "OBSERVATION-NET-07",
      "name": "Unassociated observation net",
      "type": "API_CLIENT",
      "adapter": "observation-json-v1",
      "adapter_version": "0.9.6",
      "status": "DEGRADED",
      "last_message": "14:31:42.110Z",
      "accepted": 318,
      "rejected": 11,
      "rate": "0.7 msg/s"
    }
  ],
  "zones": [
    {
      "id": "zone-bravo",
      "name": "Bravo monitoring zone",
      "label": "BRAVO",
      "points": [
        [
          20,
          66
        ],
        [
          42,
          51
        ],
        [
          67,
          57
        ],
        [
          73,
          76
        ],
        [
          48,
          88
        ],
        [
          24,
          83
        ]
      ],
      "tone": "amber"
    }
  ],
  "entities": [
    {
      "id": "UAV-018",
      "name": "Skyline 18",
      "callsign": "SKYLINE-18",
      "type": "UAV",
      "affiliation": "FRIENDLY",
      "status": "PATROL",
      "freshness": "LIVE",
      "confidence": 0.98,
      "position": {
        "x": 52,
        "y": 39,
        "lat": 28.7405,
        "lon": 93.974,
        "altitude_m": 2280
      },
      "motion": {
        "heading": 124,
        "speed": 33.3
      },
      "source_id": "SYNTH-DEMO-ALPHA",
      "source_time": "14:32:09.701Z",
      "received_at": "14:32:09.847Z",
      "trail": [
        [
          34,
          53
        ],
        [
          38,
          49
        ],
        [
          43,
          46
        ],
        [
          47,
          43
        ],
        [
          52,
          39
        ]
      ],
      "components": [
        "Identity",
        "Position",
        "Motion",
        "Operational status",
        "Health",
        "Provenance"
      ]
    },
    {
      "id": "UAV-021",
      "name": "Skyline 21",
      "callsign": "SKYLINE-21",
      "type": "UAV",
      "affiliation": "FRIENDLY",
      "status": "LOITER",
      "freshness": "LIVE",
      "confidence": 0.94,
      "position": {
        "x": 70,
        "y": 26,
        "lat": 28.877,
        "lon": 94.19,
        "altitude_m": 1920
      },
      "motion": {
        "heading": 286,
        "speed": 18.9
      },
      "source_id": "SYNTH-DEMO-ALPHA",
      "source_time": "14:32:09.691Z",
      "received_at": "14:32:09.851Z",
      "trail": [
        [
          65,
          31
        ],
        [
          66,
          29
        ],
        [
          68,
          28
        ],
        [
          70,
          26
        ]
      ],
      "components": [
        "Identity",
        "Position",
        "Motion",
        "Operational status",
        "Provenance"
      ]
    },
    {
      "id": "AC-004",
      "name": "Relay aircraft 04",
      "callsign": "RELAY-04",
      "type": "AIRCRAFT",
      "affiliation": "FRIENDLY",
      "status": "TRANSIT",
      "freshness": "AGING",
      "confidence": 0.89,
      "position": {
        "x": 78,
        "y": 58,
        "lat": 28.541,
        "lon": 94.286,
        "altitude_m": 4910
      },
      "motion": {
        "heading": 72,
        "speed": 121.2
      },
      "source_id": "SYNTH-DEMO-ALPHA",
      "source_time": "14:32:01.110Z",
      "received_at": "14:32:01.391Z",
      "trail": [
        [
          66,
          64
        ],
        [
          71,
          62
        ],
        [
          75,
          60
        ],
        [
          78,
          58
        ]
      ],
      "components": [
        "Identity",
        "Position",
        "Motion",
        "Operational status",
        "Provenance"
      ]
    },
    {
      "id": "VEH-004",
      "name": "Ground unit 04",
      "callsign": "CINDER-04",
      "type": "GROUND_VEHICLE",
      "affiliation": "FRIENDLY",
      "status": "MOVING",
      "freshness": "STALE",
      "confidence": 0.82,
      "position": {
        "x": 34,
        "y": 72,
        "lat": 28.394,
        "lon": 93.758,
        "altitude_m": 886
      },
      "motion": {
        "heading": 18,
        "speed": 12.7
      },
      "source_id": "SYNTH-GROUND-01",
      "source_time": "14:30:01.518Z",
      "received_at": "14:30:01.730Z",
      "trail": [
        [
          24,
          86
        ],
        [
          26,
          82
        ],
        [
          29,
          78
        ],
        [
          34,
          72
        ]
      ],
      "components": [
        "Identity",
        "Position",
        "Motion",
        "Operational status",
        "Provenance"
      ]
    },
    {
      "id": "VEH-019",
      "name": "Ground unit 19",
      "callsign": "CINDER-19",
      "type": "GROUND_VEHICLE",
      "affiliation": "FRIENDLY",
      "status": "HALTED",
      "freshness": "LIVE",
      "confidence": 0.97,
      "position": {
        "x": 61,
        "y": 75,
        "lat": 28.3625,
        "lon": 94.082,
        "altitude_m": 905
      },
      "motion": {
        "heading": 0,
        "speed": 0
      },
      "source_id": "SYNTH-GROUND-01",
      "source_time": "14:32:09.997Z",
      "received_at": "14:32:10.018Z",
      "trail": [
        [
          55,
          79
        ],
        [
          58,
          77
        ],
        [
          61,
          75
        ]
      ],
      "components": [
        "Identity",
        "Position",
        "Motion",
        "Operational status",
        "Provenance"
      ]
    },
    {
      "id": "SENSOR-07",
      "name": "Fixed sensor 07",
      "callsign": "WATCHTOWER-07",
      "type": "FIXED_SENSOR",
      "affiliation": "FRIENDLY",
      "status": "REPORTING",
      "freshness": "LIVE",
      "confidence": 1,
      "position": {
        "x": 19,
        "y": 44,
        "lat": 28.688,
        "lon": 93.578,
        "altitude_m": 1012
      },
      "motion": {
        "heading": 0,
        "speed": 0
      },
      "source_id": "SYNTH-GROUND-01",
      "source_time": "14:32:09.992Z",
      "received_at": "14:32:10.004Z",
      "trail": [],
      "components": [
        "Identity",
        "Position",
        "Operational status",
        "Sensor capability",
        "Provenance"
      ]
    },
    {
      "id": "OBS-337",
      "name": "Unassociated observation",
      "callsign": "OBS-337",
      "type": "UNKNOWN",
      "affiliation": "UNKNOWN",
      "status": "UNCONFIRMED",
      "freshness": "AGING",
      "confidence": 0.61,
      "position": {
        "x": 48,
        "y": 63,
        "lat": 28.4885,
        "lon": 93.926,
        "altitude_m": 0
      },
      "motion": {
        "heading": 252,
        "speed": 7.4
      },
      "source_id": "OBSERVATION-NET-07",
      "source_time": "14:31:42.001Z",
      "received_at": "14:31:42.110Z",
      "trail": [
        [
          43,
          59
        ],
        [
          46,
          61
        ],
        [
          48,
          63
        ]
      ],
      "components": [
        "Position",
        "Operational status",
        "Provenance",
        "Metadata"
      ]
    },
    {
      "id": "TEAM-012",
      "name": "Survey team 12",
      "callsign": "ORBIT-12",
      "type": "TEAM",
      "affiliation": "FRIENDLY",
      "status": "STATIONARY",
      "freshness": "LIVE",
      "confidence": 0.99,
      "position": {
        "x": 27,
        "y": 32,
        "lat": 28.814,
        "lon": 93.674,
        "altitude_m": 1164
      },
      "motion": {
        "heading": 0,
        "speed": 0
      },
      "source_id": "SYNTH-GROUND-01",
      "source_time": "14:32:10.001Z",
      "received_at": "14:32:10.011Z",
      "trail": [],
      "components": [
        "Identity",
        "Position",
        "Organization",
        "Provenance"
      ]
    }
  ],
  "alerts": [
    {
      "id": "ALERT-042",
      "severity": "WARNING",
      "type": "ZONE_ENTRY",
      "subject": "UAV-018",
      "label": "Skyline 18 entered Bravo monitoring zone",
      "time": "14:31:58Z",
      "evidence": "ZONE-ENTERED / BRAVO"
    },
    {
      "id": "ALERT-041",
      "severity": "INFO",
      "type": "FRESHNESS_CHANGED",
      "subject": "VEH-004",
      "label": "Cinder 04 moved to STALE",
      "time": "14:30:32Z",
      "evidence": "SOURCE SILENCE / 128s"
    },
    {
      "id": "ALERT-040",
      "severity": "INFO",
      "type": "STATUS_CHANGED",
      "subject": "VEH-019",
      "label": "Cinder 19 reported HALTED",
      "time": "14:29:44Z",
      "evidence": "STATUS_CHANGED"
    }
  ],
  "activity": [
    {
      "time": "14:32:09.847Z",
      "kind": "POSITION_UPDATED",
      "subject": "UAV-018",
      "source": "SYNTH-DEMO-ALPHA",
      "result": "ACCEPTED"
    },
    {
      "time": "14:32:09.701Z",
      "kind": "POSITION_UPDATED",
      "subject": "UAV-021",
      "source": "SYNTH-DEMO-ALPHA",
      "result": "ACCEPTED"
    },
    {
      "time": "14:32:01.391Z",
      "kind": "FRESHNESS_CHANGED",
      "subject": "AC-004",
      "source": "SYNTH-DEMO-ALPHA",
      "result": "PROJECTED"
    },
    {
      "time": "14:31:58.000Z",
      "kind": "ZONE_ENTERED",
      "subject": "UAV-018",
      "source": "RULES / BRAVO",
      "result": "ALERT_RAISED"
    }
  ]
}